import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { IAfterSaleService, ITermsAndPolicyEntity } from '@web-nx-ng-tsc/web-shared-data-access';

@Component({
  selector: 'lib-web-shared-ui-after-sale-service',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lib-after-sale-service.component.html',
  styleUrl: './lib-after-sale-service.component.scss',
})
export class LibAfterSaleServiceComponent {
  @Input() set data(value: IAfterSaleService) {
    this.dataSignal.set(value);
  }

  dataSignal = signal<IAfterSaleService>({
    groupImageContent: {} as ITermsAndPolicyEntity,
    groupDescriptionContent: [] as ITermsAndPolicyEntity[],
    topic: '',
  });
}
